import * as datetime from '@blueprintjs/datetime';
import { Button, Classes, Icon, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import * as React from 'react';
import { default as moment, LongDateFormatKey } from 'moment';
import MomentLocaleUtils from 'react-day-picker/moment';

export interface DateInputProps extends Partial<datetime.IDateInputProps> {
  format?: LongDateFormatKey;
  clearElement?: {
    onClick: () => void;
    isVisible: () => boolean;
  };

  formatDate?: (date: Date | null, locale?: string) => string;
  parseDate?: (str: string, locale?: string) => Date | false | null;
}

class DateInput extends React.Component<DateInputProps> {
  getMomentFormatter = (format: LongDateFormatKey, dateLocale: string): datetime.IDateInputProps => {
    moment.locale(dateLocale);
    return {
      formatDate: (date) => {
        return (date ? moment(date) : moment()).locale(dateLocale).format(format);
      },
      parseDate: (str) => {
        return str === ''
          ? null
          : moment(str, format)
              .locale(dateLocale)
              .toDate();
      },
      placeholder: moment.localeData().longDateFormat(format),
      locale: dateLocale,
    };
  };

  renderClearElement = () => {
    return this.props.clearElement && this.props.clearElement.isVisible() ? (
      <Button
        className={Classes.MINIMAL}
        icon={IconNames.CROSS}
        intent={Intent.NONE}
        onClick={this.props.clearElement.onClick}
      />
    ) : this.props.clearElement ? (
      <Icon icon={IconNames.BLANK} iconSize={30} />
    ) : (
      undefined
    );
  };

  render() {
    const { clearElement, ...rest } = this.props;
    const maxDate =
      rest.maxDate != null
        ? rest.maxDate
        : moment()
            .add(3, 'year')
            .toDate();
    const minDate = moment().add(-5, 'year').toDate();
    return (
      <datetime.DateInput
        popoverProps={{ usePortal: true, modifiers: { preventOverflow: { enabled: false } } }}
        rightElement={this.renderClearElement()}
        showActionsBar={true}
        canClearSelection={true}
        {...this.getMomentFormatter(this.props.format || 'L', this.props.locale || 'fr')}
        {...rest}
        maxDate={maxDate}
        minDate={minDate}
        dayPickerProps={{
          firstDayOfWeek: 1,
          localeUtils: MomentLocaleUtils,
          locale: 'fr',
          showOutsideDays: false,
        }}
      />
    );
  }
}

export default DateInput;
